import React from "react";

const WifiTierRepeater = ({
  tiers,
  aircraftTypeId,
  aircraftTypeName,
  onAdd,
  onRemove,
  onChange,
  maxTiers = 4,
}) => {
  const toPercentageDisplay = (decimal) => {
    if (decimal === null || decimal === undefined || decimal === "") return "";
    return (decimal * 100).toFixed(2);
  };

  const handleFieldChange = (tierIndex, field, value) => {
    let processedValue = value;
    
    // Convert percentage input to decimal for addOnPercent field
    if (field === "addOnPercent") {
      // Allow null for "not available"
      if (value === "" || value === null) {
        processedValue = null;
      } else {
        processedValue = parseFloat(value) / 100;
      }
    } else if (field === "year") {
      processedValue = value === "" ? null : parseInt(value);
    }
    
    onChange(aircraftTypeId, tierIndex, field, processedValue);
  };

  return (
    <div className="ctf-wifi-repeater">
      {tiers && tiers.length > 0 ? (
        <div className="ctf-wifi-tiers">
          {tiers.map((tier, index) => (
            <div key={index} className="ctf-wifi-tier">
              <div className="ctf-form-group">
                <label htmlFor={`wifi-year-${aircraftTypeId}-${index}`}>Year</label>
                <input
                  type="number"
                  id={`wifi-year-${aircraftTypeId}-${index}`}
                  min="1980"
                  max="2030"
                  value={tier.year || ""}
                  placeholder="e.g., 2004"
                  onChange={(e) =>
                    handleFieldChange(index, "year", e.target.value)
                  }
                />
              </div>

              <div className="ctf-form-group">
                <label htmlFor={`wifi-addOnPercent-${aircraftTypeId}-${index}`}>
                  WiFi Add-On %
                </label>
                <div className="ctf-percentage-input">
                  <input
                    type="number"
                    id={`wifi-addOnPercent-${aircraftTypeId}-${index}`}
                    step="0.01"
                    value={toPercentageDisplay(tier.addOnPercent)}
                    placeholder="Leave empty = not available"
                    onChange={(e) =>
                      handleFieldChange(index, "addOnPercent", e.target.value)
                    }
                  />
                  <span className="ctf-percentage-symbol">%</span>
                </div>
                <small className="ctf-helper-text">
                  Enter as percentage (e.g., 12 for 12% add-on). Leave empty if WiFi not available for this year.
                </small>
              </div>

              <button
                type="button"
                className="ctf-btn ctf-btn-danger ctf-btn-remove"
                onClick={() => onRemove(aircraftTypeId, index)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="ctf-no-tiers">No WiFi tiers configured for this aircraft type.</p>
      )}

      {(!tiers || tiers.length < maxTiers) && (
        <button
          type="button"
          className="ctf-btn ctf-btn-secondary"
          onClick={() => onAdd(aircraftTypeId)}
        >
          + Add WiFi Tier
        </button>
      )}
    </div>
  );
};

export default WifiTierRepeater;
